import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const StencilContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ThumbContainer = styled.div`
  position: relative;
`;

const ThumbHeader = styled.div`
  padding-bottom: 133.3%;
  background-color: ${props => props.theme.colors.gray150};
`;

const Details = styled.div`
  padding: ${props =>
    `${props.theme.spacing.tiny}px ${props.theme.spacing.tiny}px 170px`};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

const ProductName = styled.h4`
  margin: 0;
  background-color: ${props => props.theme.colors.gray150};
  width: 120px;
  height: 18px;
`;

export default class GridStencil extends React.Component {
  static propTypes = {
    /**
     * The amount of grid items to render
     */
    slotCount: PropTypes.number.isRequired,
    /**
     * Position asset slots so layout does not shift from
     * loading state to loaded
     */
    assetSlots: PropTypes.object,
  };

  static defaultProps = {
    assetSlots: null,
  };

  renderItem = (item, index) => {
    return item.isAsset ? (
      React.cloneElement(item.element, { key: index })
    ) : (
      <StencilContainer key={index}>
        <ThumbContainer>
          <ThumbHeader />
        </ThumbContainer>
        <Details>
          <ProductName />
        </Details>
      </StencilContainer>
    );
  };

  render() {
    const { assetSlots, slotCount } = this.props;
    const slots = Array.from({ length: slotCount }, _ => {
      return { isAsset: false };
    });

    if (assetSlots) {
      Object.keys(assetSlots).forEach(index => {
        const indexNumber = parseInt(index, 10);
        const assetItem = {
          isAsset: true,
          element: assetSlots[index],
        };
        slots.splice(indexNumber, 0, assetItem);
      });
    }

    return <>{slots.map(this.renderItem)}</>;
  }
}
